import { createQueryKey } from '../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../query/types';

const consumerNewsletterKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys, 'newsletters'] as const,
    id: <U extends QueryKeyParam>(newsletterId: U) =>
      createQueryKey({
        all: [...keys, 'newsletters', newsletterId] as const,
      }),
  });

const consumerKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys] as const,
    newsletters: consumerNewsletterKeys([...keys] as const),
  });

export { consumerKeys };
